import { useController } from '@framework/form/hooks/useController.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { ConfirmWidgetLayoutComponent } from './components/ConfirmWidgetLayoutComponent.tsx';
import { ConfirmWidgetValue, type IConfirmWidget } from './IConfirmWidget.ts';

export interface IConfirmWidgetComponentProps
  extends IWidgetComponentProps<IConfirmWidget> {}

/**
 * Componente che gestisce la logica di un widget di tipo `Confirm`
 * nel Form.
 */
export function ConfirmWidgetFormComponent(
  props: IConfirmWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const {
    field: { value, onChange, onBlur },
  } = useController(options.name, {
    defaultValue: ConfirmWidgetValue.Unconfirmed,
  });

  return (
    <ConfirmWidgetLayoutComponent
      options={options}
      onChange={onChange}
      onBlur={onBlur}
      confirmationValue={value}
      {...props}
    />
  );
}
